// ----------------------------------------------------------------
//                        自定義 手機(台灣) 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "mobile",
    function (value, element) {
        var re = /^09[0-9]{8}$/i;

        return value.length === 0 || re.test(value);
    },
    "手機號碼格式錯誤"
);
// ----------------------------------------------------------------
//                        自定義 Youtube 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "youtube",
    function (value, element) {
        let regex =
            /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,})/;

        return value.length === 0 || regex.test(value);
    },
    "Youtube 格式錯誤"
);

// ----------------------------------------------------------------
//                   自定義 是否給予的2個欄位的值是相同的規則
// ----------------------------------------------------------------
$.validator.addMethod("equal_values", function (value, element, param) {
    return $(param).val() == value;
});

// ----------------------------------------------------------------
//                          自定義 上圖必填 區域
// ----------------------------------------------------------------
/**
 * rules:{
        image_input: {
            picture: '{ "old_input":"nick_name_icon_o", "div":".rd_image_border" }'
        }
    }
 * @param param JSON 文字 (param 參數只能帶文字進來);  JSON 中,
 *              必須有舊的 input 的 name 以及 要被變色的 div 的 div id / class
 *              例: '{ "old_input":"nick_name_icon_o", "div":".rd_image_border" }'
 */
var picture_input_border_color = null;
$.validator.addMethod(
    "picture",
    function (value, element, param) {
        var params = JSON.parse(param);
        var old_input = $('input[name="' + params.old_input + '"]').val(); // 之前儲存過的圖片的檔名
        var target_div = $(element).closest(params.div); // 要被變更 border color 的 div

        // 沒舊的紀錄, 也沒加新的圖片
        if (old_input === "" && $(element).val() === "") {
            // 記錄舊的顏色
            if (picture_input_border_color == null) {
                picture_input_border_color =
                    target_div.css("border-left-color");
            } // end of if

            // 把 border 改成紅色
            target_div.css({ "border-color": "#dc3545" });

            return false;
        } else {
            // 把 border 恢復成原本顏色
            target_div.css({ "border-color": picture_input_border_color });

            return true;
        } // end of if
    },
    "必需上傳一張圖片"
);

// ----------------------------------------------------------------
//                      自定義 date_range 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "date_start",
    function (value, element, param) {
        var params = JSON.parse(param);
        var start_input = $('input[name="' + params.start + '"]');
        var end_input = $('input[name="' + params.end + '"]');
        var start_date = start_input.val();
        var end_date = end_input.val();

        if (Date.parse(end_date).valueOf() < Date.parse(start_date).valueOf()) {
            return false;
        } else {
            return true;
        } // end of if
    },
    "起始日期不得大於結束日期"
);

// ----------------------------------------------------------------
//                      　　 唯一值規則
// ----------------------------------------------------------------
/**
 * rules:{
      "film_type[]":{
           unique : 'select[name="film_type[]"]'
       },
    }
 * @param check_for 能夠用來找到所有要比對的dom的字串: 例: 'input[name="country"]'
 */
$.validator.addMethod("unique", function (value, dom, check_for) {
    var less_than_two = true;

    $.each($(check_for), function (index, d) {
        // 如果不是自己（目前focus的dom）
        if (dom != d && $(d).val() == value) {
            less_than_two = false;
        }
    });

    return less_than_two;
});

$.validator.addMethod(
    "pwcheck",
    function (value, element) {
        let code = /([A-Za-z]{1}[0-9]{1})|([0-9]{1}[A-Za-z]{1})/;

        return this.optional(element) || code.test(value);
    },
    "請填入8-12含英文與數字"
);

// ----------------------------------------------------------------
//                      　　 聯絡電話判斷
// ----------------------------------------------------------------
$.validator.addMethod(
    "phone",
    function (value, element) {
        return this.optional(element) || /^[\d|\-|\#|\*|\(|\)]+$/g.test(value);
    },
    "請輸入聯絡電話"
);

// ----------------------------------------------------------------
//                      　　 公司統一編號判斷
// ----------------------------------------------------------------
$.validator.addMethod(
    "taxNumber",
    function (value, element) {
        var invoice_number = value;
        var result = false;

        if (!isNaN(parseInt(invoice_number))) {
            var invoice_number_split = invoice_number
                .split("")
                .map(function (data) {
                    return +data;
                });
            var cardinal_number = new Array(1, 2, 1, 2, 1, 2, 4, 1);
            var compute = 0;
            invoice_number_split.forEach(function (data, i) {
                var t = cardinal_number[i] * data;

                if (t > 9) {
                    t.toString()
                        .split("")
                        .forEach(function (data) {
                            compute += +data;
                        });
                } else {
                    compute += t;
                }
            });

            if (compute % 10 == 0) {
                result = true;
            } else if (
                invoice_number_split[6] == 7 &&
                (compute + 1) % 10 == 0
            ) {
                result = true;
            }
        }

        return this.optional(element) || result;
    },
    "統一編號格式錯誤"
);

// ----------------------------------------------------------------
//                      自定義 CkEditor 規則
// ----------------------------------------------------------------
$.validator.addMethod(
    "ck_editor",
    function (value, element, param) {
        let element_id = $(element).prop("id");
        let element_name = $(element).prop("name");
        let editor_id =
            "cke_" +
            (element_id != undefined && element_id != ""
                ? element_id
                : element_name);
        let editor = $("#" + editor_id);

        if (param === true) {
            if (editor.length > 0) {
                var iframe = editor.find("iframe");
                var body = iframe.contents().find("body");

                if (body.html() != "" && body.html() != "<br>") {
                    editor
                        .closest(".rd_show_validator_error")
                        .find("div:first")
                        .css("border", "1px solid #ddd");
                    editor
                        .closest(".rd_show_validator_error")
                        .find(".rd_notice")
                        .remove();
                    return true;
                } else {
                    editor
                        .closest(".rd_show_validator_error")
                        .find("div:first")
                        .css("border", "1px solid #dc3545");
                    return false;
                }
            } // end of if
        }
        return true;
    },
    "此為必填欄位"
);

// ----------------------------------------------------------------
//                      自定義 Summernote 規則
// ----------------------------------------------------------------
let summernoteBorderCss = null;
$.validator.addMethod(
    "summernote",
    function (value, element, param) {
        let textarea = $(element);
        let container = textarea.closest(".rd_required");
        let summernoteFrame = container.find(".note-frame");

        // 記錄舊的顏色
        if (summernoteBorderCss == null) {
            summernoteBorderCss = summernoteFrame.css("border");
        } // end of if

        // textarea.summernote('isEmpty') 不會檢查使用者輸入空白, 需要自己檢查看看是否只有填寫空白字串
        let text = $(element).summernote("code");

        text = text.replaceAll(/\s|(&nbsp;)/g, ""); // 移除所有空白
        text = text.replaceAll(/(<p>|<\/p>|<br>)*/g, ""); // 移除所有空標籤

        if (text === "") {
            summernoteFrame.css("border", "1px solid #dc3545");
            return false;
        } // end of if

        // 有填寫
        container.find(".rd_notice").remove(); // 移除錯誤訊息
        summernoteFrame.css("border", summernoteBorderCss); // 還原 border 顏色

        return true;
    },
    "此為必填欄位"
);

$.validator.addMethod(
    "synchronousRemote",
    function (value, element, param) {
        if (this.optional(element)) {
            return "dependency-mismatch";
        }

        var previous = this.previousValue(element);
        if (!this.settings.messages[element.name]) {
            this.settings.messages[element.name] = {};
        }
        previous.originalMessage = this.settings.messages[element.name].remote;
        this.settings.messages[element.name].remote = previous.message;

        param = (typeof param === "string" && { url: param }) || param;

        if (previous.old === value) {
            return previous.valid;
        }

        previous.old = value;
        var validator = this;
        this.startRequest(element);
        var data = {};
        data[element.name] = value;
        var valid = "pending";
        $.ajax(
            $.extend(
                true,
                {
                    url: param,
                    async: false,
                    mode: "abort",
                    port: "validate" + element.name,
                    dataType: "json",
                    data: data,
                    success: function (response) {
                        validator.settings.messages[element.name].remote =
                            previous.originalMessage;
                        valid = response === true || response === "true";
                        if (valid) {
                            var submitted = validator.formSubmitted;
                            validator.prepareElement(element);
                            validator.formSubmitted = submitted;
                            validator.successList.push(element);
                            delete validator.invalid[element.name];
                            validator.showErrors();
                        } else {
                            var errors = {};
                            var message =
                                response ||
                                validator.defaultMessage(element, "remote");
                            errors[element.name] = previous.message =
                                $.isFunction(message)
                                    ? message(value)
                                    : message;
                            validator.invalid[element.name] = true;
                            validator.showErrors(errors);
                        }
                        previous.valid = valid;
                        validator.stopRequest(element, valid);
                    },
                },
                param
            )
        );
        return valid;
    },
    "Please fix this field."
);

$.validator.addMethod(
    "check_password",
    function (value) {
        if (value) {
            if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W+).{12,}$/.test(value)) {
                return true;
            }
            return false;
        }
        return true;
    },
    "The password must be at least 12 characters long and contain alphanumeric characters and symbols, one uppercase English letter, one lowercase English letter, one symbol and one number."
);
